import React, {useContext, useEffect, useMemo, useRef, useState} from 'react';
import ReactMapboxGl, {Marker, Popup} from 'react-mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import {useTheme, withStyles, makeStyles, MuiThemeProvider} from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import RoomIcon from '@material-ui/icons/Room';
import {
    checkin_report_url,
    ck_checkin_columns,
    ck_u_username,
    defDateFormat,
    empty,
    mapbox_key,
    req_acc_project,
    req_branch_per_cust,
    req_checkin,
    req_checkin_merchandising,
    req_checkin_sched,
    req_checkin_sched_amend,
    req_checkin_summary,
    req_cust,
    req_custby_salesman,
    req_merchandiser,
    req_module_setting,
    req_region,
    req_salesman,
	req_cust_area,
	req_cust_category,
	req_cust_chain,
	req_cust_type,
	req_stocktemplate,
    reset,
	req_cust_approve,
	req_sp_cust_relationship,
	req_totalcustnotinlistcount,
	req_custnotinlist,
	req_checkin_delete,
	req_cust_branches,
	req_mobile_module_setting
} from '../../Helper/Constants';
import {red, yellow} from '@material-ui/core/colors';
import {usePaperStyles} from '../../Styles/StylePaper';
import {useCommonStyles} from '../../Styles';
import moment from 'moment';
import AppContext from '../../Services/AppContext';
import {useSnackbar} from 'notistack';
import PersistantData from '../../Services/PersistantData';
import JString from '@easytech-international-sdn-bhd/jstring';
import API_Service, {axiosDefaultConfig, axiosPutConfig, axiosURIencode} from '../../Services/API_Service';
import format from 'date-fns/format';
import {
    Badge,
    Backdrop,
    BottomNavigation,
    BottomNavigationAction,
    Chip,
    CircularProgress,
    DialogContent,
    DialogContentText,
    Divider,
    IconButton,
    Tooltip,
    Typography
} from '@material-ui/core';
import {
    Assessment as AssessmentIcon,
    ClearAll,
    FilterList as FilterListIcon,
    FindInPage,
    KeyboardArrowRightRounded,
    Person as PersonIcon,
    PinDrop,
    ViewList
} from '@material-ui/icons';
import {pure} from 'recompose';
import MUIDataTable from 'mui-datatables';
import CheckinDetails from '../../Components/CheckinDetails';
import CheckDetailsCell from './components/CheckDetailsCell';
import DataTableFilter, {createDataTableFilterTheme, isColumnDisplayed} from '../../Components/DataTableFilter';
import _, { stubFalse } from 'lodash';
import DoneIcon from '@material-ui/icons/Done';
import CloseIcon from '@material-ui/icons/Close';
import ScheduleIcon from '@material-ui/icons/Schedule';
import KeyboardArrowDownRoundedIcon from '@material-ui/icons/KeyboardArrowDownRounded';
import VirtualList from '../../Components/VirtualList';
import BusinessIcon from '@material-ui/icons/Business';
import {de, getSetting, isPromoter} from '../../Helper/Helper';
import TvIcon from '@material-ui/icons/Tv';
import ListView from '../../Components/ListView';
import {useFullScreenHandle} from "react-full-screen";
import Fab from '@material-ui/core/Fab';
import DateRangePickerModal from '../../Components/DateRangePickerModal';
import EventNoteIcon from '@material-ui/icons/EventNote';
import AnyDialog from '../../Components/AnyDialog';
import AddAppointmentMerchandiser from './AddAppointmentMerchandiser';
import AddVisitSched from './AddVisitSched';
import ColorRandomizer from '../../Helper/ColorRandomizer';
import WarningIcon from '@material-ui/icons/Warning';
import WorkOutlineIcon from '@material-ui/icons/WorkOutline';
import MapIcon from '@material-ui/icons/Map';
import {useCookies} from 'react-cookie';
import SendSMS from "../../Components/SendSMS";
import GenerateView from "../../Components/GenerateView";
import useCookieHook from "../../Services/useCookieHook";
import useColumnPreference from '../../Services/useColumnPreference';
import VisibilityIcon from '@material-ui/icons/Visibility';
import ThumbUpIcon from '@material-ui/icons/ThumbUp';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import ThumbDownIcon from '@material-ui/icons/ThumbDown';
import VirtualListMB from '../../Components/VirtualListMB';
import AddCustomer from '../../Components/AddCustomer';
import NewReleasesIcon from '@material-ui/icons/NewReleases';

import LinearLoading from '../../Components/LinearLoading';

const parseTotalBreakTime = (breakTime) => {
	if (!breakTime || breakTime === '[]') return '-';
	try {
		const parsed = typeof breakTime === 'string' ? JSON.parse(breakTime) : breakTime;
		if (Array.isArray(parsed) || !parsed) return '-';
		return parsed.total_break_time || '-';
	} catch (e) {
		return '-';
	}
};

const useStyles = makeStyles(theme => ({
	backdrop: {
		zIndex: theme.zIndex.drawer + 1,
		color: '#fff',
	},
}));

const ClearButton = withStyles(theme => ({
	root: {
		borderColor: red[500]
	}
}))(Button);

const CustomDotRender = ({times}) => {
	const dummy = new Array(times).fill(0);
	return (
		<div
			style={{
				display: 'flex',
				justifyContent: 'flex-start',
				paddingLeft: 5,
				alignItems: 'center',
				flexDirection: 'row'
			}}>
			{
				dummy.map((item, index) =>
					<Badge variant={'dot'} color={'primary'} style={{marginRight: 10}}/>
				)
			}
		</div>
	)
}
const workloadCell = [
	{
		name: "name",
		label: "Assignee"
	},
	{
		name: "date",
		label: "Date"
	},
	{
		name: "08:00",
		label: "08:00",
		options: {
			display: true,
			filter: false,
			customBodyRender: (value, tableMeta, updateValue) => {
				return (
					<CustomDotRender
						times={value}
					/>
				)
			}
		}
	},
	{
		name: "09:00",
		label: "09:00",
		options: {
			display: true,
			filter: false,
			customBodyRender: (value, tableMeta, updateValue) => {
				return (
					<CustomDotRender
						times={value}
					/>
				)
			}
		}
	},
	{
		name: "10:00",
		label: "10:00",
		options: {
			display: true,
			filter: false,
			customBodyRender: (value, tableMeta, updateValue) => {
				return (
					<CustomDotRender
						times={value}
					/>
				)
			}
		}
	},
	{
		name: "11:00",
		label: "11:00",
		options: {
			display: true,
			filter: false,
			customBodyRender: (value, tableMeta, updateValue) => {
				return (
					<CustomDotRender
						times={value}
					/>
				)
			}
		}
	},
	{
		name: "12:00",
		label: "12:00",
		options: {
			display: true,
			filter: false,
			customBodyRender: (value, tableMeta, updateValue) => {
				return (
					<CustomDotRender
						times={value}
					/>
				)
			}
		}
	},
	{
		name: "13:00",
		label: "13:00",
		options: {
			display: true,
			filter: false,
			customBodyRender: (value, tableMeta, updateValue) => {
				return (
					<CustomDotRender
						times={value}
					/>
				)
			}
		}
	},
	{
		name: "14:00",
		label: "14:00",
		options: {
			display: true,
			filter: false,
			customBodyRender: (value, tableMeta, updateValue) => {
				return (
					<CustomDotRender
						times={value}
					/>
				)
			}
		}
	},
	{
		name: "15:00",
		label: "15:00",
		options: {
			display: true,
			filter: false,
			customBodyRender: (value, tableMeta, updateValue) => {
				return (
					<CustomDotRender
						times={value}
					/>
				)
			}
		}
	},
	{
		name: "16:00",
		label: "16:00",
		options: {
			display: true,
			filter: false,
			customBodyRender: (value, tableMeta, updateValue) => {
				return (
					<CustomDotRender
						times={value}
					/>
				)
			}
		}
	},
	{
		name: "17:00",
		label: "17:00",
		options: {
			display: true,
			filter: false,
			customBodyRender: (value, tableMeta, updateValue) => {
				return (
					<CustomDotRender
						times={value}
					/>
				)
			}
		}
	},
	{
		name: "18:00",
		label: "18:00",
		options: {
			display: true,
			filter: false,
			customBodyRender: (value, tableMeta, updateValue) => {
				return (
					<CustomDotRender
						times={value}
					/>
				)
			}
		}
	},
	{
		name: "19:00",
		label: "19:00",
		options: {
			display: true,
			filter: false,
			customBodyRender: (value, tableMeta, updateValue) => {
				return (
					<CustomDotRender
						times={value}
					/>
				)
			}
		}
	}
];

const schedHeadCell = [
	{
		name: "sched_code",
		label: "Code",
		options: {
			display: true
		}
	},
	{
		name: "name",
		label: "Assignee",
		options: {
			display: true
		}
	},
	{
		name: "cust_company_name",
		label: "Customer",
		options: {
			display: true
		}
	},
	{
		name: "sched_datetime",
		label: "Appointment At",
		options: {
			display: true,
			filter: false,
			customBodyRender: (value, tableMeta, updateValue) => {
				return (
					moment(value, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY hh:mm A')
				)
			}
		}
	},
	{
		name: "sched_note",
		label: "Note",
		options: {
			display: true
		}
	},
	{
		name: "site_in_charge",
		label: "In-charge",
		options: {
			display: true,
			filter: false
		}
	},
	{
		name: "site_in_charge_contact",
		label: "In-charge Contact",
		options: {
			display: false,
			filter: false
		}
	},
	{
		name: "sched_status",
		label: "Appointment Status",
		options: {
			display: true,
			customBodyRender: (value, tableMeta, updateValue) => {
				switch (value) {
					case "0" :
						return (<Chip size="small" icon={<ScheduleIcon/>} label="Pending"/>);
						break;
					case "1" :
						return (<Chip size="small" icon={<DoneIcon/>} label="Completed"/>);
						break;
					case "2" :
						return (<Chip size="small" icon={<CloseIcon/>} label="Reject"/>);
						break;
					default :
						return (<Chip size="small" icon={<ScheduleIcon/>} label="Pending"/>);
						break;
				}
			}
		}
	},
	{
		name: "in_progress",
		label: "Progress",
		options: {
			display: true,
			customBodyRender: (value, tableMeta, updateValue) => {
				switch (value) {
					case "0" :
						return (<Chip size="small" icon={<WarningIcon/>} label="Pending"/>);
						break;
					case "1" :
						return (<Chip size="small" icon={<ScheduleIcon color={'primary'}/>} label="Running"/>);
						break;
					case "2" :
						return (<Chip size="small" icon={<DoneIcon/>} label="Done"/>);
						break;
					default :
						return (<Chip size="small" icon={<ScheduleIcon/>} label="Pending"/>);
						break;
				}
			}
		}
	},
	{
		name: "project_no",
		label: "Projects",
		options: {
			display: true,
			filter: false,
			customBodyRender: (value, tableMeta, updateValue) => {
				if (JString(value).isJson()) {
					const json = JString(value).toJson();
					return (
						<div>
							{
								json.map((item, index) =>
									<Chip
										style={{marginBottom: 2}}
										size="small"
										label={item.project_code}
										key={'chip-project-' + index}/>
								)
							}
						</div>
					)
				}
			}
		}
	},
	{
		name: "tags",
		label: "-",
		options: {
			display: true,
			filter: false,
			customBodyRender: (value, tableMeta, updateValue) => {
				if (JString(value).isJson()) {
					const json = JString(value).toJson();
					const colors = ColorRandomizer({
						luminosity: 'bright',
						hue: 'blue',
						count: Object.keys(json).length
					});
					return (
						<div>
							{
								Object.keys(json).map((key, index) =>
									<div key={String(index) + '--div'}>
										<span style={{color: 'grey', fontSize: 14}}>{String(key).toUpperCase()}</span>
										<div style={{display: 'flex', flexDirection: 'row'}}>
											{
												json[key].map((item, nidx) =>
													<Chip
														style={{backgroundColor: colors[index], color: 'white'}}
														size="small"
														label={item}
														key={'chip' + nidx}/>
												)
											}
										</div>
									</div>)
							}
						</div>
					)
				}
			}
		}
	},
	{
		name: "updated_at",
		label: "Updated At",
		options: {
			display: true,
			filter: false,
			customBodyRender: (value, tableMeta, updateValue) => {
				return (
					moment(value, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY hh:mm A')
				)
			}
		}
	},
	{
		name: "created_by",
		label: "Created By",
		options: {
			display: true,
			filter: false
		}
	}
];

const statusList = [
	{
		name: 'Pending',
		value: '0'
	},
	{
		name: 'Running',
		value: '1'
	},
	{
		name: 'Complete',
		value: '2'
	},
	{
		name: 'Missed',
		value: '3'
	}
];
const appointmentHeadCell = [
	{
		name: "staff_code",
		label: "Agent"
	},
	{
		name: "num_of_appointments",
		label: "Visit Count",
		options: {
			display: true,
			filter: false,
			customBodyRender: (value, tableMeta, updateValue) => {
				return (
					<Typography variant={'caption'} color={'textPrimary'}>
						{value} Places
					</Typography>
				)
			}
		}
	},
	{
		name: "start_date",
		label: "Start Date",
		options: {
			display: true,
			filter: false,
			customBodyRender: (value, tableMeta, updateValue) => {
				return (
					moment(value, 'YYYY-MM-DD').format('DD/MM/YYYY')
				)
			}
		}
	},
	{
		name: "end_date",
		label: "End Date",
		options: {
			display: true,
			filter: false,
			customBodyRender: (value, tableMeta, updateValue) => {
				return (
					moment(value, 'YYYY-MM-DD').format('DD/MM/YYYY')
				)
			}
		}
	}
];

const scheduleTableHead = [
	{
		name: "technician",
		label: "Technician",
		options: {
			display: true
		}
	},
	{
		name: "eight",
		label: "8AM",
		options: {
			display: true,
			customBodyRender: (value, tableMeta, updateValue) => {
				return (
					<Typography style={{whiteSpace: 'pre-line'}}>
						{
							value
						}
					</Typography>
				)
			}
		}
	},
	{
		name: "nine",
		label: "9AM",
		options: {
			display: true,
			customBodyRender: (value, tableMeta, updateValue) => {
				return (
					<Typography style={{whiteSpace: 'pre-line'}}>
						{
							value
						}
					</Typography>
				)
			}
		}
	},
	{
		name: "ten",
		label: "10AM",
		options: {
			display: true,
			customBodyRender: (value, tableMeta, updateValue) => {
				return (
					<Typography style={{whiteSpace: 'pre-line'}}>
						{
							value
						}
					</Typography>
				)
			}
		}
	},
	{
		name: "eleven",
		label: "11AM",
		options: {
			display: true,
			customBodyRender: (value, tableMeta, updateValue) => {
				return (
					<Typography style={{whiteSpace: 'pre-line'}}>
						{
							value
						}
					</Typography>
				)
			}
		}
	},
	{
		name: "twelve",
		label: "12AM",
		options: {
			display: true,
			customBodyRender: (value, tableMeta, updateValue) => {
				return (
					<Typography style={{whiteSpace: 'pre-line'}}>
						{
							value
						}
					</Typography>
				)
			}
		}
	},
	{
		name: "one",
		label: "1PM",
		options: {
			display: true,
			customBodyRender: (value, tableMeta, updateValue) => {
				return (
					<Typography style={{whiteSpace: 'pre-line'}}>
						{
							value
						}
					</Typography>
				)
			}
		}
	},
	{
		name: "two",
		label: "2PM",
		options: {
			display: true,
			customBodyRender: (value, tableMeta, updateValue) => {
				return (
					<Typography style={{whiteSpace: 'pre-line'}}>
						{
							value
						}
					</Typography>
				)
			}
		}
	},
	{
		name: "three",
		label: "3PM",
		options: {
			display: true,
			customBodyRender: (value, tableMeta, updateValue) => {
				return (
					<Typography style={{whiteSpace: 'pre-line'}}>
						{
							value
						}
					</Typography>
				)
			}
		}
	},
	{
		name: "four",
		label: "4PM",
		options: {
			display: true,
			customBodyRender: (value, tableMeta, updateValue) => {
				return (
					<Typography style={{whiteSpace: 'pre-line'}}>
						{
							value
						}
					</Typography>
				)
			}
		}
	},
	{
		name: "five",
		label: "5PM",
		options: {
			display: true,
			customBodyRender: (value, tableMeta, updateValue) => {
				return (
					<Typography style={{whiteSpace: 'pre-line'}}>
						{
							value
						}
					</Typography>
				)
			}
		}
	},
	{
		name: "six",
		label: "6PM",
		options: {
			display: true,
			customBodyRender: (value, tableMeta, updateValue) => {
				return (
					<Typography style={{whiteSpace: 'pre-line'}}>
						{
							value
						}
					</Typography>
				)
			}
		}
	},
	{
		name: "seven",
		label: "7PM",
		options: {
			display: true,
			customBodyRender: (value, tableMeta, updateValue) => {
				return (
					<Typography style={{whiteSpace: 'pre-line'}}>
						{
							value
						}
					</Typography>
				)
			}
		}
	}
]

const makebranchname = (obj) => {
	return JString(obj.branch_name)
			.replaceInfinity('[\(\)]', '')
			.replaceInfinity(obj.branch_code, '')
			.str.trim()
		||
		'-';
}

const makeaddress = (obj) => {
  return [
    obj.billing_address1,
    obj.billing_address2,
    obj.billing_address3,
    obj.billing_address4
  ]
    .filter(Boolean)     // 过滤空值、null、undefined、空字符串
    .join(' ');          // 用空格拼接
};

// 保存筛选条件到localStorage的函数
const saveFilterConditions = (filterList) => {
	try {
		localStorage.setItem('checkin_agent_filters', JSON.stringify(filterList));
	} catch (error) {
		console.error('Failed to save filter conditions:', error);
	}
};

// 从localStorage加载筛选条件的函数
const loadFilterConditions = () => {
	try {
		const saved = localStorage.getItem('checkin_agent_filters');
		return saved ? JSON.parse(saved) : []; // 没有保存数据时返回空数组
	} catch (error) {
		console.error('Failed to load filter conditions:', error);
		return []; // 出错时返回空数组
	}
};

// custom筛选的过滤逻辑，返回true代表该行被筛掉
const filterValueLogic = (value, filters) => {
	if (!filters || filters.length === 0) {
		return false;
	}
	const current = value === null || value === undefined ? '' : String(value).trim();
	return filters.indexOf(current) === -1;
};

export default function Checkin() {
	const classes = useStyles();
	const checkinDataRef = useRef([]);
	const pendingDataRef = useRef([]);
	const checkinDataMapRef = useRef({});
	// 以列名为key保存MUIDataTable当前的筛选条件，columns重建时回填
	const filterListRef = useRef(null);
	// 初始化headCell状态，从localStorage加载Agent筛选条件
	const [headCell, setHeadCell] = useState([
		{
			name: "mobile_checkin_id",
			label: "Doc ID",
			options: {
				display: false
			}
		},
		{
			name: "name",
			label: "Agent",
			options: {
				display: false,
				filterType: 'multiselect',
				filterList: loadFilterConditions()
			}
		},
		{
			name: "staff_code",
			label: "Agent Code",
			options: {
				display: false,
				filterType: 'multiselect'
			}
		},
		{
			name: "person_met",
			label: "Person Met",
			options: {
				display: false
			}
		},
		{
			name: "cust_company_name",
			label: "Outlet",
			options: {
				display: true,
				filterType: 'multiselect'
			}
		},
		{
			name: "area_name",
			label: "Area",
			options: {
				display: true
			}
		},
		// {
		// 	name: "company",
		// 	label: "Branch",
		// 	options: {
		// 		display: true,
		// 		customBodyRender: (value) => value ? value.toUpperCase() : ''
		// 	}
		// },
		{
			name: "create_date",
			label: "Date",
			options: {
				display: false,
				filter: false,
				customBodyRender: (value, tableMeta, updateValue) => {
					return (
						moment(value, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY hh:mm A')
					)
				}
			}
		},
		{
			name: "checkin_details",
			label: "Check-In Details",
			options: {
				display: true,
				viewColumns: false,
				sort: false,
				filter: false,
				download: false,
				customBodyRender: (value, tableMeta) => {
					const id = tableMeta.rowData[0];
					const row = checkinDataMapRef.current[id];
					if (!row) return null;
					return <CheckDetailsCell type="checkin" row={row} />;
				}
			}
		},
		{
			name: "checkout_details",
			label: "Check-Out Details",
			options: {
				display: true,
				viewColumns: false,
				sort: false,
				filter: false,
				download: false,
				customBodyRender: (value, tableMeta) => {
					const id = tableMeta.rowData[0];
					const row = checkinDataMapRef.current[id];
					if (!row) return null;
					return <CheckDetailsCell type="checkout" row={row} />;
				}
			}
		},
		{
			name: "checkin_time",
			label: "Checked-In",
			options: {
				display: false,
				viewColumns: false,
				filter: false,
				customBodyRender: (value, tableMeta, updateValue) => {
					if (!value || value === '0000-00-00 00:00:00') return '';
					return moment(value, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY hh:mm A');
				}
			}
		},
		{
			name: "checkout_time",
			label: "Checked-Out",
			options: {
				display: false,
				viewColumns: false,
				filter: false,
				customBodyRender: (value, tableMeta, updateValue) => {
					if (!value || value === '0000-00-00 00:00:00') return '';
					return moment(value, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY hh:mm A');
				}
			}
		},
		{
			name: "total_break_time",
			label: "Total Break Time",
			options: {
				display: true,
				filter: false,
			}
		},
		{
			name: "checkin_location_map",
			label: "Checked-In At",
			options: {
				display: false,
				viewColumns: false,
				customBodyRender: (value, tableMeta, updateValue) => {
					return (
						<a href={'https://www.google.com/search?q='+value} target='_blank' style={{color:'#fff'}}>{value}</a>
					)
				}
			}
		},
		{
			name: "checkout_location_map",
			label: "Checked-Out At",
			options: {
				display: false,
				viewColumns: false,
				customBodyRender: (value, tableMeta, updateValue) => {
					return (
						<a href={'https://www.google.com/search?q='+value} target='_blank' style={{color:'#fff'}}>{value}</a>
					)
				}
			}
		},
		{
			name: "status",
			label: "Status",
			options: {
				display: true,
				filter: false,
				customBodyRender: (value) => {
					if (parseInt(value) === 1) return <Chip size="small" style={{backgroundColor: '#ff9800', color: '#fff'}} label="In Progress"/>;
					if (parseInt(value) === 2) return <Chip size="small" style={{backgroundColor: '#4caf50', color: '#fff'}} label="Completed"/>;
					return '';
				}
			}
		},
		{
			name: "distance",
			label: "Distance",
			options: {
				display: false,
				viewColumns: false,
				customBodyRender: (value) => {
					// 解析距离数值 (移除 ' m' 并转换为浮点数)
					const distance = parseFloat(String(value).replace(' m', ''));
					
					// 单位转换逻辑: 如果 >= 1000m，转换为 km 并保留2位小数
					let displayValue = value;
					if (!isNaN(distance) && distance >= 1000) {
						displayValue = (distance / 1000).toFixed(2) + ' km';
					}

					// 判断逻辑: 如果是有效数字且 >= 500，则应用警告样式
					const isAlert = !isNaN(distance) && distance >= 500;

					if (isAlert) {
						return (
							<span style={{
								display: 'inline-block',
								backgroundColor: '#fff1f0', // Ant Design Red-1 (更干净的淡红)
								color: '#cf1322',           // Ant Design Red-7 (沉稳的深红)
								border: '1px solid #ffa39e',// Ant Design Red-3 (清晰的边框)
								padding: '2px 10px',        // 调整内边距，使其更扁平精致
								borderRadius: '4px',        // 改为小圆角 (4px)，比胶囊形更适合 B 端表格
								fontWeight: '500',          // 稍微降低字重，避免过于粗重
								fontSize: '0.85rem',
								minWidth: '70px',
								textAlign: 'center',
								lineHeight: '1.5'
							}}>
								{displayValue}
							</span>
						);
					}
					
					// 普通数值或 "-" 的显示逻辑
					return (
						<span style={{ 
							color: value === '-' ? '#bdbdbd' : 'inherit', // "-" 显示为浅灰色
							fontWeight: value === '-' ? 'normal' : '500' 
						}}>
							{displayValue}
						</span>
					);
				}
			}
		},
		{
			name: "checkout_distance",
			label: "Checkout Distance",
			options: {
				display: false,
				viewColumns: false
			}
		},
		{
			name: "new_potential_outlet",
			label: "New Potential Outlet",
			options: {
				display: true,
			}
		},
		{
			name: "cust_reference",
			label: "Customer Ref",
			options: {
				display: false
			}
		},
		{
			name: "remark1",
			label: "Remark",
			options: {
				display: false
			}
		},
		{
			name: "remark2",
			label: "Remark 2",
			options: {
				display: false
			}
		},
		{
			name: "remark3",
			label: "Remark 3",
			options: {
				display: false,
				customBodyRender: (value, tableMeta, updateValue) => {
					const isjson = JString(value).isJson();
					var remark = '';
					for (let i = 0; i < value?.length; i++) {
						if (value[i]['code'] === 'collection') {
							remark += value[i]['value'];
							if (value[i]['selected'] !== '') {
								remark += ' Yes\n';
							}
							remark += '';
						}

					}
					if (isjson) {
						return isjson.toJson()?.str || '';
					} else {
						return (
							<Typography style={{whiteSpace: 'pre-line'}}>
								{
									remark
								}
							</Typography>
						)
					}
				}
			}
		},
		{
			name: "schedule",
			label: "Scheduled For",
			options: {
				display: false,
				customBodyRender: (value, tableMeta, updateValue) => {
					if(Object.keys(value).length > 0){
						return moment(value.appmnt_date).format('DD/MM/YYYY');
					}else{
						return "";
					}
					// const isjson = JString(value).isJson();
					// if (isjson) {
					// 	const json = isjson.toJson();
					// 	return json.sched_note + ' ' + moment(json.sched_date).format('DD/MM/YYYY');
					// } else {
					// 	return value;
					// }
				}
			}
		},
		// {
		// 	name: "st_id",
		// 	label: "Stock Take ID",
		// 	options: {
		// 		display: false,
		// 		customBodyRender: (value, tableMeta, updateValue) => {
		// 			var id = '';
		// 			const isjson = JString(value).isJson();
		// 			if (value) {
		// 				for (let i = 0; i < value.length; i++) {
		// 					id += value[i]['st_id'];
		// 					id += '\n';
		// 				}
		// 				if (isjson) {
		// 					return isjson.toJson()?.str || '';
		// 				} else {
		// 					return (
		// 						<Typography style={{whiteSpace: 'pre-line'}}>
		// 							{
		// 								id
		// 							}
		// 						</Typography>
		// 					)
		// 				}
		// 			}
		// 		}
		// 	}
		// },
		{
			name: "role_name",
			label: "Role",
			options: {
				display: true,
				customBodyRender: (value, tableMeta) => {
					const id = tableMeta.rowData[0];
					const row = checkinDataMapRef.current[id];
					if (row && isPromoter(row.position)) {
						return (<Chip size="small" style={{backgroundColor: '#FF9800', color: '#fff'}} label={'Promoter'}/>);
					}
					switch (value) {
						case "Manager":
							return (<Chip size="small" style={{backgroundColor: 'orangered', color: '#fff'}} label={value}/>);
						case "Agent":
							return (<Chip size="small" style={{backgroundColor: 'yellowgreen', color: '#fff'}} label={value}/>);
						default:
							return ("-");
					}
				}
			}
		},
		{
			name: "app_type",
			label: "App Type",
			options: {
				display: true,
				customBodyRender: (value, tableMeta, updateValue) => {
					let style = {};

					switch (value) {
						case "EasyM" :
							style = {backgroundColor: yellow[900]};
							break;
						case "EasyTeam" :
							style = {backgroundColor: "yellowgreen"};
							break;
						default :
							style = {};
							break;
					}
					return (<Chip size="small" style={style} label={value} />);
				}
			}
		},
		{
			name: "action",
			label: "Action",
			options: {
				display: true,
				download: false,
				customBodyRender: (value, tableMeta, updateValue) => {
					if(showPending){
						return (
							<>
								<Chip size="small" style={{backgroundColor: "yellowgreen", marginRight: 5}}
									onClick={()=>
										approve(tableMeta.rowData[0])
									}
									label={'Confirm'}
								/>
								<Chip size="small" style={{backgroundColor: red[500]}}
									onClick={()=>
										decline(tableMeta.rowData[0])
									}
									label={'Delete'}
								/>
							</>
						);
					}else{
						return <></>
					}
				}
			}
		}
	]);
	const paperStyle = usePaperStyles();
	const commonStyles = useCommonStyles();
	const fullscreenManager = useFullScreenHandle();

	const [xCookies] = useCookieHook([ck_u_username]);
	const current_username = xCookies(ck_u_username);

	const theme = useTheme();
	const lightTheme = theme.palette.type === 'light';

	const [gState, setGState] = useContext(AppContext);
	const [isSearching, setSearching] = useState(false);
	const {enqueueSnackbar, closeSnackbar} = useSnackbar();
	const [configLoading, setConfigLoading] = useState(true);

	const [filterOpen, showFilter] = useState(false);
	const [addnewSched, showNewSched] = useState(false);

	const [regionList, setRegionList] = useState([]);
	const [regionView, setRegionView] = useState(false);
	const [regionSelected, setRegionSelected] = useState(empty);

	const [tchList, setTchList] = useState([]);
	const [mchList, setMchList] = useState([]);
	const [spList, setSpList] = useState([]);
	const [spValue, setSpValue] = useState(empty);
	const [spView, setSpView] = useState(false);
	const [statusView, setStatusView] = useState(false);
	const [status, setStatus] = useState(empty);

	const [rawCustomers, setRawCustomers] = useState([]);

	const [branchPercustomer, setBranchPerCustomer] = useState({});
	const [csList, setCsList] = useState([]);
	const [csOutstanding, setCsOutstanding] = useState({});
	const [csValue, setCsValue] = useState('');
	const [isCustomerView, showCustomerView] = useState(false);

	const [currentPage, setCurrentPage] = useState(0);

	const [projectData, setProjectData] = useState([]);
	const [checkinData, setCheckinData] = useState([]);
	const [pendingData, setPendingData] = useState([]);
	useEffect(() => {
		checkinDataRef.current = checkinData;
		pendingDataRef.current = pendingData;
		const m = {};
		checkinData.forEach(r => { if (r && r.mobile_checkin_id) m[r.mobile_checkin_id] = r; });
		pendingData.forEach(r => { if (r && r.mobile_checkin_id) m[r.mobile_checkin_id] = r; });
		checkinDataMapRef.current = m;
	}, [checkinData, pendingData]);
	const [scheduleData, setScheduleData] = useState([]);
	const [schedData, setSchedData] = useState([]);

	const [checkinDataToview, setCheckinDataToView] = useState([]);
	const [latlongList, setLatlongList] = useState([]);
	const [axiosApiConfig, setAxiosApiConfig] = useState({});

	const [summaryData, setSummaryData] = useState([]);
	const [presentationData, setPresentationData] = useState([]);
	const [workloadData, setWorkloadData] = useState([]);
	const [appointmentData, setAppointmentData] = useState({});

	const [selectedMch, setSelectedMch] = useState('');
	const [schedTabPosition, setSchedTabPosition] = useState(0);

	const [openDateDoc, setOpenDateDoc] = useState(false);
	const [docDateRange, setDocDateRange] = useState({});

	const [customModule, setCustomModule] = useState({});
	const [addVisitSchedRules, setAddVisitSchedRules] = useState({});
	const [appointmentGroups, setAppointmentGroups] = useState([]);

	const [checkinConfig, setCheckinConfig] = useState('');

	const [editSched, setEditSched] = useState({open: false, editData: {}});

	const [smsView, setSMSView] = useState(false);
	const [schedCode, setSchedCode] = useState([]);

	const [printView, setPrintView] = useState();

	const [showPending, setShowPending] = useState(false);
	const [showDetails, setShowDetails] = useState(false);
	const [showApprovementDialog, setShowApprovementDialog] = useState(false);
	const [showApprovementList, setShowApprovementList] = useState([]);
	const [showCreateCustomerDialog, setShowCreateCustomerDialog] = useState(false);
	const [approveData, setApproveData] = useState(null);
	const [activeCustAreaList, setActiveCustAreaList] = useState([]);
	const [activeCustTypeList, setActiveCustTypeList] = useState([]);
	const [activeCustCategoryList, setActiveCustCategoryList] = useState([]);
	const [activeCustChainList, setActiveCustChainList] = useState([]);
	const [branchesList, setBranchesList] = useState([]);
	const [pendingCustomerCount, setPendingCustomerCount] = useState(0);
	const [stockTemplateList, setStockTemplateList] = useState([]);

	const [tableStatus, setTableStatus] = useState(false);
	const [tableHead, setTableHead] = useState([]);
	const [confirmDialog, setConfirmDialog] = useState({
		open: false,
		message: '',
		onConfirm: () => {}
	});
	const [isLoading, setIsLoading] = useState(false);

	const singleton = PersistantData.getInstance();
	var {translation: language, client} = gState;
	if (typeof (language) === 'undefined') {
		language = singleton.getlang()
	}
	const { columns: preferredColumns, onColumnViewChange: onPrefColumnViewChange } = useColumnPreference('Checkin', headCell, client);

	// 切换列显示：只存后端。不重建columns（重建会让MUIDataTable整表重算），Filter弹窗按实时列状态自行判断
	const onColumnViewChanged = (changedColumn, action) => {
		onPrefColumnViewChange(changedColumn, action);
	};

	const typeOptions = [
		{name: 'Basic Version', value: 'simply'},
		{name: 'Detailed Version', value: 'normal'}
	]

	const dateMenuOptions = {name: language.doc_date, value: reset};

	const FORCE_HIDDEN_COLUMNS = ['checkin_time', 'checkout_time', 'checkin_location_map', 'checkout_location_map', 'distance', 'checkout_distance'];
	const FORCE_VISIBLE_COLUMNS = ['checkin_details', 'checkout_details'];
	const redefineHeaders = (columns, status = false, pendingStatus) => {
		const actionColumn = columns.find(column => column.name === "action");
		const actionDisplay = actionColumn && actionColumn.options ? actionColumn.options.display : true;
		columns = columns.filter(column => column.name !== "action");
		if (status !== true) {
			columns = columns.filter(column => column.name !== "app_type");
		}
		columns = columns.map(col => {
			if (FORCE_HIDDEN_COLUMNS.includes(col.name)) {
				const clone = _.merge({}, col);
				clone.options = { ...clone.options, display: false, viewColumns: false };
				return clone;
			}
			if (FORCE_VISIBLE_COLUMNS.includes(col.name)) {
				const clone = _.merge({}, col);
				clone.options = { ...clone.options, display: true, viewColumns: false };
				clone.label = col.name === 'checkin_details' ? language.checkin_dtl : language.checkout_dtl;
				return clone;
			}
			if (col.name === 'staff_code') {
				const clone = _.merge({}, col);
				clone.label = language.agent_code;
				return clone;
			}
			return col;
		});
		columns.push({
			name: "action",
			label: "Action",
			options: {
				display: actionDisplay,
				download: false,
				filter: false,
				customBodyRender: (value, tableMeta, updateValue) => {
					if(pendingStatus){
						return (
							<>
								<Chip size="small" style={{backgroundColor: "yellowgreen", marginRight: 5}}
									onClick={()=>
										approve(tableMeta.rowData[0])
									}
									label={'Confirm'}
								/>
								<Chip size="small" style={{backgroundColor: red[500]}}
									onClick={()=>
										decline(tableMeta.rowData[0])
									}
									label={'Delete'}
								/>
							</>
						);
					}else{
						return <></>
					}
				}
			}
		});
		if (pendingStatus) {
			columns = columns.map((item) => {
				if (item.name === 'distance') {
					var objCopy = _.merge({}, item);
					objCopy.options.display = false;
					return objCopy;
				}
				return item;
			});
		}
		// Filter弹窗按MUIDataTable实时列可见状态只渲染显示中的列，并回填已选筛选条件
		columns = columns.map(col => {
			const options = {...col.options};
			if (options.filter !== false) {
				options.filter = true;
			}
			const savedFilter = filterListRef.current && filterListRef.current[col.name];
			if (savedFilter) {
				options.filterList = savedFilter;
			}
			if (options.filter) {
				options.filterType = 'custom';
				options.filterOptions = {
					logic: filterValueLogic,
					display: (filterList, onChange, index, column) => isColumnDisplayed(column) && (
						<DataTableFilter
							index={index}
							name={column.name}
							label={column.label}
							rows={pendingStatus ? pendingDataRef.current : checkinDataRef.current}
							selected={filterList[index] || []}
							onChange={(values) => onChange(values, index, column)}
							language={language}
						/>
					)
				};
				options.customFilterListOptions = {
					render: (values) => values.map(value => `${col.label}: ${value}`),
					update: (filterList, filterPos, index) => {
						filterList[index].splice(filterPos, 1);
						return filterList;
					}
				};
			}
			return {...col, options};
		});
		return columns;
	}

	useEffect(() => {
		if (JString(gState.client).isValid()) {
			var axiosGetConfig = axiosDefaultConfig(gState.client);
			loadRegion(axiosGetConfig)
			loadCustomerList(axiosGetConfig);
			loadSalesmanList(axiosGetConfig);
			loadMerchandiserList(axiosGetConfig);
			loadCheckConfig(axiosGetConfig);
			loadBranchPerCustomer(axiosGetConfig);
			loadProjectData(axiosGetConfig);
			setAxiosApiConfig(axiosGetConfig);
			loadCustAreaList(axiosGetConfig);
			loadCustTypeList(axiosGetConfig);
			loadStockTemplateList(axiosGetConfig);
			loadCustCategoryList(axiosGetConfig);
			loadCustChainList(axiosGetConfig);
			loadTotalRecord(axiosGetConfig);
			loadBranchList(axiosGetConfig);
			statusList.push({name: language.status, value: reset});
		}
	}, [gState.client]);

	useEffect(() => {
		if (preferredColumns.length > 0) {
			setTableHead(redefineHeaders(preferredColumns, tableStatus, showPending));
		}
		// csList 不参与列构建，加入依赖会在客户列表加载完成时重建columns并清空筛选
	}, [tableStatus, showPending, /* csList, */ preferredColumns])

	const loadCustAreaList = (axiosRequestConfig) => {
        API_Service.get(req_cust_area, axiosRequestConfig).then(({data}) => {
            if (data) {
                var {result, extraData } = data;
                result = JString(result).toNumber();
                if (result === 1) {
                    var _inact_data = [];
                    var _act_data = [];
                    for (let i = 0; i < extraData.length; i++) {
                        const element = extraData[i];
                        if(JString(element['area_status']).toNumber() === 1){
                            _act_data.push(element);
                        }
                    }
                    // setCustomerAreaList(() => (extraData));
                    setActiveCustAreaList(()=>(_act_data));
                }
            }
        }).catch(err => de(err.message, 'customer area list'));
    }

	const loadCustTypeList = (axiosRequestConfig) => {
		API_Service.get(req_cust_type, axiosRequestConfig).then(({ data }) => {
			if (data) {
				var { result, extraData } = data;
				result = JString(result).toNumber();
				if (result === 1) {
					var _inact_data = [];
					var _act_data = [];
					for (let i = 0; i < extraData.length; i++) {
						const element = extraData[i];
						if (JString(element['status']).toNumber() === 1) {
							_act_data.push(element);
						} else {
							_inact_data.push(element);
						}
					}
					setActiveCustTypeList(() => (_act_data));
				}
			}
		}).catch(err => de(err.message, 'customer type list'));
	}

	const loadStockTemplateList = (axiosRequestConfig) => {
		API_Service.get(`${req_stocktemplate}?active_status=1`, axiosRequestConfig).then(({data}) => {
			if (data) {
				var {result, extraData } = data;
				result = JString(result).toNumber();
				if (result === 1) {
					setStockTemplateList(extraData);
				}
			}
		});
	}

	const loadCustCategoryList = (axiosRequestConfig) => {
		API_Service.get(`${req_cust_category}`, axiosRequestConfig).then(({data}) => {
			if (data) {
				var {result, extraData } = data;

				result = JString(result).toNumber();
				if (result === 1) {
					var _inact_data = [];
					var _act_data = [];
					for (let i = 0; i < extraData.length; i++) {
						const element = extraData[i];
						if(element['cust_category_status'] == 1){
							_act_data.push(element);
						}else{
							_inact_data.push(element);
						}
					}
					setActiveCustCategoryList(()=>(_act_data));
				}
			}
		}).catch(err => de(err.message, 'customer category list'));
	}

	const loadCustChainList = (axiosRequestConfig) => {
		API_Service.get(`${req_cust_chain}`, axiosRequestConfig).then(({data}) => {
			if (data) {
				var {result, extraData } = data;
				result = JString(result).toNumber();
				if (result === 1) {
					var _inact_data = [];
					var _act_data = [];
					for (let i = 0; i < extraData.length; i++) {
						const element = extraData[i];
						if(element['cust_chain_status'] == 1){
							_act_data.push(element);
						}else{
							_inact_data.push(element);
						}
					}
					setActiveCustChainList(()=>(_act_data));
				}
			}
		}).catch(err => de(err.message, 'customer chain list'));
	}

	const loadTotalRecord = (axiosRequestConfig = axiosApiConfig) => {
		API_Service.get(`${req_totalcustnotinlistcount}?company=${gState.company}`, axiosRequestConfig).then(({data}) => {
			if (data) {
				var {result, extraData } = data;
				result = JString(result).toNumber();
				if (result === 1) {
					setPendingCustomerCount(extraData);
				}
			}
		}).catch(err => de(err.message, 'total record pending customer'));
	}

	const loadBranchList = (axiosRequestConfig) => {
        API_Service.get(req_cust_branches, axiosRequestConfig).then(({data}) => {
            if (data) {
                var {result, extraData } = data;
                result = JString(result).toNumber();
				var _data = [];
                if (result === 1) {
					for (let i = 0; i < extraData.length; i++) {
						if (gState.company) {
							const company = JSON.parse(gState.company);
							if (company.includes(extraData[i]['value'])) {
								_data.push(extraData[i]);	
							}
						} else {
							_data.push(extraData[i]);
						}
					}
					setBranchesList(_data);
                }
            }
        }).catch(err => de(err.message, 'customer branch list'));
    }

	const loadCustNotInListCheckinData = (axiosRequestConfig = axiosApiConfig) => {
		setPendingData([]);
		var parameters = '';
		if (gState.company) {
			const param = axiosURIencode({
				company: gState.company,
			});
			parameters = `?${param}`;
		}

		API_Service.get(`${req_custnotinlist}${parameters}`, axiosRequestConfig).then(({data}) => {
			if (data) {
				var {result, extraData } = data;
				const tablePendingData = [];
				if (extraData.length > 0) {
					for (let index = 0; index < extraData.length; index++) {
						const obj = extraData[index];
						const {mobile_checkin_id, location_lng, location_lat, name, remark3} = obj;
						var tmp = remark3;
						var cust_ref = '';
						const isjson = JString(remark3).isJson();
						if (tmp !== '' && tmp != null) {
							try {
								tmp = JSON.parse(tmp);
								if(tmp.hasOwnProperty('obj')){
									tmp = tmp['obj'];
									for (let i = 0; i < tmp.length; i++) {
										if (tmp[i]['code'] === 'newcustomer') {
											cust_ref = tmp[i]['value'];
										}
									}
								}
							} catch (e) {
								de(`remark3 JSON parse failed: ${e.message}`);
								tmp = remark3;
							}
						}

						obj.remark3 = tmp;
						obj.cust_ref = cust_ref;

						if (obj?.schedule) {
							tmp = obj?.schedule;
							const isjson = JString(tmp).isJson();
							if (isjson) {
								tmp = isjson.toJson()?.sched_note || '';
							}
							obj.schedule = tmp;
						}
						if(obj.customer_not_in_list_info){
							const customer_not_in_list_info = JString(obj.customer_not_in_list_info).isJson();
							const new_cust_info = customer_not_in_list_info.toJson();
							if(new_cust_info.length > 0){
								obj.pending_customer = new_cust_info;
							}
						}
						if(obj.cust_company_name == '--'){
							if(obj.pending_customer){
								obj.cust_company_name = obj.pending_customer[0]['outlet_name'];
								obj.checkin_location = obj.pending_customer[0]['outlet_address'];
							}
							tablePendingData.push(obj);
						}
					}
					setPendingData(tablePendingData);
					snack(language.checkin_loaded);
				} else {
					snack(language.no_data, "warning");
				}
			}
		}).catch(err => de(err.message, 'total record customer not in list checkin data'));
	}

	const loadCustNotInListCheckinData2 = (axiosRequestConfig = axiosApiConfig) => {
		setPendingData([]);
		var parameters = '';
		if (gState.company) {
			const param = axiosURIencode({
				company: gState.company,
			});
			parameters = `?${param}`;
		}

		API_Service.get(`${req_custnotinlist}${parameters}`, axiosRequestConfig).then(({data}) => {
			if (data) {
				var {result, extraData } = data;
				const tablePendingData = [];
				if (extraData.length > 0) {
					for (let index = 0; index < extraData.length; index++) {
						const obj = extraData[index];
						const {mobile_checkin_id, location_lng, location_lat, name, remark3} = obj;
						var tmp = remark3;
						var cust_ref = '';
						const isjson = JString(remark3).isJson();
						if (tmp !== '' && tmp != null) {
							try {
								tmp = JSON.parse(tmp);
								if(tmp.hasOwnProperty('obj')){
									tmp = tmp['obj'];
									for (let i = 0; i < tmp.length; i++) {
										if (tmp[i]['code'] === 'newcustomer') {
											cust_ref = tmp[i]['value'];
										}
									}
								}
							} catch (e) {
								de(`remark3 JSON parse failed: ${e.message}`);
								tmp = remark3;
							}
						}

						obj.remark3 = tmp;
						obj.cust_ref = cust_ref;

						if (obj?.schedule) {
							tmp = obj?.schedule;
							const isjson = JString(tmp).isJson();
							if (isjson) {
								tmp = isjson.toJson()?.sched_note || '';
							}
							obj.schedule = tmp;
						}
						if(obj.customer_not_in_list_info){
							const customer_not_in_list_info = JString(obj.customer_not_in_list_info).isJson();
							const new_cust_info = customer_not_in_list_info.toJson();
							if(new_cust_info.length > 0){
								obj.pending_customer = new_cust_info;
							}
						}
						if(obj.cust_company_name == '--'){
							if(obj.pending_customer){
								obj.cust_company_name = obj.pending_customer[0]['outlet_name'];
								obj.checkin_location = obj.pending_customer[0]['outlet_address'];
							}
							tablePendingData.push(obj);
						}
					}
					setPendingData(tablePendingData);
					setShowPending(false);
					setShowPending(true);
					snack(language.checkin_loaded);
				} else {
					snack(language.no_data, "warning");
				}
			}
		}).catch(err => de(err.message, 'total record customer not in list checkin data'));
	}

	const decideAndLoad = (type = checkinConfig, axiosConfig = axiosApiConfig) => {
		loadCheckinData(axiosConfig, type);
		loadCustNotInListCheckinData(axiosConfig);
		if (type === 'merchandising') {
			de('loading appointment')
			// loadAppointmentData(axiosConfig);
			loadAppointmentGroup(axiosConfig);
		} else {
			loadSchedData(axiosConfig);
			// loadSummaryData(axiosConfig);
		}
	}

	const loadProjectData = (axiosGetConfig) => {
		API_Service.get(req_acc_project, axiosGetConfig).then(({data}) => {
			const {result, extraData} = data;
			if (result) {
				setProjectData(extraData);
			}
		});
	}

	const loadCheckConfig = (axiosGetConfig) => {
		API_Service.get(req_module_setting, axiosGetConfig).then(({data}) => {
			const {result, extraData} = data;
			if (result == 1) {
				const config = getSetting(extraData, 'checkin', {schedule: ''});
				const custommodule = getSetting(extraData, 'sched_tags');
				const visitSchedRules = getSetting(extraData, 'add_visit_sched');
				const _modules = getSetting(extraData, 'modules', {});

				decideAndLoad(config, axiosGetConfig);
				setCheckinConfig(config);
				setCustomModule(custommodule);
				setAddVisitSchedRules(visitSchedRules);

				if (_modules['branch'] == true) {
					setHeadCell(prevTableHead => [
						...prevTableHead.slice(0, 5),
						{
							name: "company",
							label: "Branch",
							options: {
								display: true,
								customBodyRender: (value) => value ? value.toUpperCase() : ''
							}
						},
						...prevTableHead.slice(5)
					]);
				}
			} else {
				decideAndLoad('', axiosGetConfig);
				setCheckinConfig('')
			}
			setConfigLoading(false);
		}).catch(err => {
			setConfigLoading(false);
		});
		API_Service.get(req_mobile_module_setting, axiosGetConfig).then(({data}) => {
			const {result, extraData} = data;
			if (result == 1) {
				const {module, pdf_images} = extraData;
				for (let m = 0; m < module.length; m++) {
					if (module[m]['module'] === 'app_checkin_type') {
						let setting = parseInt(module[m]['status']);
						if (setting) {
							setTableStatus(true);
						}
					}
				}
			}
		});
	}
	const makeSearchProp = () => {
		var salesperson_id, date_from, date_to, region;
		var cust_code = JString(csValue?.value).isSafe();
		if (JString(spValue).isValid()) {
			salesperson_id = spValue;
		} else {
			salesperson_id = 0;
		}
		if (!_.isEmpty(docDateRange)) {
			date_from = format(docDateRange.startDate, defDateFormat);
			date_to = format(docDateRange.endDate, defDateFormat);
		} else {
			date_from = '';
			date_to = '';
		}

		if (cust_code) {
			cust_code = csValue?.value || '';
		}

		if (JString(regionSelected).isValid()) {
			region = regionSelected;
		}

		date_from = date_from === reset ? '' : date_from;
		date_to = date_to === reset ? '' : date_to;
		cust_code = cust_code === reset ? '' : cust_code;
		salesperson_id = salesperson_id === reset ? '' : salesperson_id;
		region = region === reset ? '' : region;

		return {date_from, date_to, salesperson_id, cust_code, region};
	}

	const loadAppointmentGroup = (axiosConfig = axiosApiConfig) => {
		setAppointmentGroups([]);
		const params = axiosURIencode({group: 1});
		API_Service.get(`${req_checkin_merchandising}?${params}`, axiosConfig).then(({data}) => {
			const {result, extraData} = data;
			if (parseInt(result) == 1) {
				setAppointmentGroups(extraData);
			}
		});
	}
	const loadAppointmentData = (axiosConfig = axiosApiConfig) => {
		setAppointmentData([]);
		setSearching(true);
		const {date_from, date_to, salesperson_id, cust_code, region} = makeSearchProp();
		var obj = {
			active_status: 1,
			date_from,
			date_to,
			salesperson_id,
			cust_code,
			region
		};
		if (!date_from) {
			obj.date_from = moment().startOf('month').format('YYYY-MM-DD');
			obj.date_to = moment().add(1, 'month').endOf('month').format('YYYY-MM-DD');
		}
		if (obj.region === undefined || obj.region === null) {
			obj.region = '';
		}
		var params = axiosURIencode(obj);
		API_Service.get(`${req_checkin_merchandising}?${params}`, axiosConfig).then(({data}) => {
			const {extraData} = data;
			const {pending, appointments} = extraData;
			setScheduleData(pending);
			setAppointmentData(appointments);
			setSearching(false);
			showFilter(false);
		}).catch(e => setSearching(true));
	}

	const loadSummaryData = (axiosConfig = axiosApiConfig) => {
		setSummaryData([]);
		setSearching(true);
		const {date_from, date_to, salesperson_id, cust_code} = makeSearchProp();
		var obj = {
			active_status: 1,
			date_from,
			date_to,
			salesperson_id,
			cust_code,
			status
		};
		var params = axiosURIencode(obj);
		API_Service.get(`${req_checkin_summary}?${params}`, axiosConfig).then(({data}) => {
			const {result, extraData} = data;
			if (result) {
				const {summary, presentation, workload} = extraData;
				setSummaryData(summary);
				setPresentationData(presentation);
				setWorkloadData(workload);
				showFilter(false);
				setSearching(false);
				if (summary.length < 0 && currentPage === 2) {
					snack(language.no_data, 'warning');
				}
				if (workload.length < 0 && currentPage === 3) {
					snack(language.no_data, 'warning');
				}
				var _arr = [];
				for (let idx = 0; idx < summary.length; idx++) {
					var arr = [];
					var obj = {};

					obj = Object.assign(obj, {technician: summary[idx]['title'] + '(' + summary[idx]['label'].toString() + ')'});
					arr.push({technician: summary[idx]['title'] + '(' + summary[idx]['label'].toString() + ')'});

					var cards = summary[idx]['cards'];
					for (let c = 0; c < cards.length; c++) {
						var time = moment(cards[c]['date']).format('H');
						if (time === '08') {
							arr['08.00'] = arr['08.00'] ? arr['08.00'] + ' \n ' + cards[c]['title'] + '[' + cards[c]['client'] + ']' : cards[c]['title'] + '[' + cards[c]['client'] + ']';
							obj = Object.assign(obj, {'eight': arr['08.00']});
						} else if (time === '09') {
							arr['09.00'] = arr['09.00'] ? arr['09.00'] + ' \n ' + cards[c]['title'] + '[' + cards[c]['client'] + ']' : cards[c]['title'] + '[' + cards[c]['client'] + ']';
							obj = Object.assign(obj, {'nine': arr['09.00']});
						} else if (time === '10') {
							arr['10.00'] = arr['10.00'] ? arr['10.00'] + ' \n ' + cards[c]['title'] + '[' + cards[c]['client'] + ']' : cards[c]['title'] + '[' + cards[c]['client'] + ']';
							obj = Object.assign(obj, {'ten': arr['10.00']});
						} else if (time === '11') {
							arr['11.00'] = arr['11.00'] ? arr['11.00'] + ' \n ' + cards[c]['title'] + '[' + cards[c]['client'] + ']' : cards[c]['title'] + '[' + cards[c]['client'] + ']';
							obj = Object.assign(obj, {'eleven': arr['11.00']});
						} else if (time === '12') {
							arr['12.00'] = arr['12.00'] ? arr['12.00'] + ' \n ' + cards[c]['title'] + '[' + cards[c]['client'] + ']' : cards[c]['title'] + '[' + cards[c]['client'] + ']';
							obj = Object.assign(obj, {'twelve': arr['12.00']});
						} else if (time === '13') {
							arr['13.00'] = arr['13.00'] ? arr['13.00'] + ' \n ' + cards[c]['title'] + '[' + cards[c]['client'] + ']' : cards[c]['title'] + '[' + cards[c]['client'] + ']';
							obj = Object.assign(obj, {'one': arr['13.00']});
						} else if (time === '14') {
							arr['14.00'] = arr['14.00'] ? arr['14.00'] + ' \n ' + cards[c]['title'] + '[' + cards[c]['client'] + ']' : cards[c]['title'] + '[' + cards[c]['client'] + ']';
							obj = Object.assign(obj, {'two': arr['14.00']});
						} else if (time === '15') {
							arr['15.00'] = arr['15.00'] ? arr['15.00'] + ' \n ' + cards[c]['title'] + '[' + cards[c]['client'] + ']' : cards[c]['title'] + '[' + cards[c]['client'] + ']';
							obj = Object.assign(obj, {'three': arr['15.00']});
						} else if (time === '16') {
							arr['16.00'] = arr['16.00'] ? arr['16.00'] + ' \n ' + cards[c]['title'] + '[' + cards[c]['client'] + ']' : cards[c]['title'] + '[' + cards[c]['client'] + ']';
							obj = Object.assign(obj, {'four': arr['16.00']});
						} else if (time === '17') {
							arr['17.00'] = arr['17.00'] ? arr['17.00'] + ' \n ' + cards[c]['title'] + '[' + cards[c]['client'] + ']' : cards[c]['title'] + '[' + cards[c]['client'] + ']';
							obj = Object.assign(obj, {'five': arr['17.00']});
						} else if (time === '18') {
							arr['18.00'] = arr['18.00'] ? arr['18.00'] + ' \n ' + cards[c]['title'] + '[' + cards[c]['client'] + ']' : cards[c]['title'] + '[' + cards[c]['client'] + ']';
							obj = Object.assign(obj, {'six': arr['18.00']});
						} else if (time === '19') {
							arr['19.00'] = arr['19.00'] ? arr['19.00'] + ' \n ' + cards[c]['title'] + '[' + cards[c]['client'] + ']' : cards[c]['title'] + '[' + cards[c]['client'] + ']';
							obj = Object.assign(obj, {'seven': arr['19.00']});
						}
					}
					_arr.push(obj);
				}
				setSchedData(_arr);
			} else {
				setSummaryData([]);
				setPresentationData([]);
				setWorkloadData([]);
				snack(language.no_data, 'error');
				showFilter(false);
				setSearching(false);
			}

		}).catch(e => setSearching(true));
	}
	const generateCheckinReport = (type) => {
		setPrintView(false);
		const {date_from, date_to, salesperson_id} = makeSearchProp();
		const date_range = `${date_from} to ${date_to}`;
		const client = gState.client;
		const url = checkin_report_url(client, salesperson_id, date_range, type);
		window.open(url, '_blank');
	}
	const loadSchedData = (axiosConfig = axiosApiConfig) => {
		setScheduleData([]);
		setSearching(true);
		var {date_from, date_to, salesperson_id, cust_code} = makeSearchProp();
		if (!date_from) {
			date_from = moment().format('YYYY-MM-DD');
			date_to = moment().add(2, 'months').format('YYYY-MM-DD');
		}
		var params = {
			date_from,
			date_to,
			sched_status: 0,
			active_status: 1,
			status
		};
		if (salesperson_id) {
			params = {...params, tech_assigned: salesperson_id}
		}
		if (cust_code) {
			params = {...params, cust_code}
		}
		if (regionSelected) {
			var region = getRegion(regionSelected);
			params = {...params, region};
		}
		params = axiosURIencode(params);
		API_Service.get(`${req_checkin_sched}?${params}`, axiosConfig).then(({data}) => {
			const {result, extraData} = data;
			if (result) {
				if (extraData.length > 0) {
					setScheduleData(extraData);
				} else {
					snack(language.no_data, "warning");
				}
			}

			setSearching(false);
		});
	}

	const loadCheckinData = (axiosConfig = axiosApiConfig, type = checkinConfig) => {
		setCheckinData([]);
		setSearching(true);

		var {date_from, date_to, salesperson_id, cust_code} = makeSearchProp();
		var parameters = {
			date_from,
			date_to,
			cust_code,
			salesperson_id,
			type
		};
		if (gState.company) {
			parameters = {
				...parameters, 
				company: gState.company
			};
		}
		var params = axiosURIencode(parameters);
		API_Service.get(`${req_checkin}?${params}`, axiosConfig).then(({data}) => {
			const {result, extraData} = data;
			if (result) {
				const list = [];
				const tableData = [];
				if (extraData.length > 0) {
					for (let index = 0; index < extraData.length; index++) {
						const obj = extraData[index];
						const {mobile_checkin_id, location_lng, location_lat, name, remark3, marker_color, info_questionnaire} = obj;
						var tmp = remark3;
						var cust_ref = '';
						const isjson = JString(remark3).isJson();
						// if(isjson){
						if (tmp !== '' && tmp != null) {
							// tmp = isjson.toJson()?.str || '';
							try {
								tmp = JSON.parse(tmp);
								if(tmp.hasOwnProperty('obj')){
									tmp = tmp['obj'];
									for (let i = 0; i < tmp.length; i++) {
										if (tmp[i]['code'] === 'newcustomer') {
											cust_ref = tmp[i]['value'];
										}
									}
								}
							} catch (e) {
								de(`remark3 JSON parse failed: ${e.message}`);
								tmp = remark3;
							}
						}

						obj.remark3 = tmp;
						obj.cust_ref = cust_ref;

						if (obj?.schedule) {
							tmp = obj?.schedule;
							const isjson = JString(tmp).isJson();
							if (isjson) {
								tmp = isjson.toJson()?.sched_note || '';
							}
							obj.schedule = tmp;
						}
						if(obj.customer_not_in_list_info){
							const customer_not_in_list_info = JString(obj.customer_not_in_list_info).isJson();
							const new_cust_info = customer_not_in_list_info.toJson();
							if(new_cust_info.length > 0){
								obj.pending_customer = new_cust_info;
							}
						}
						obj.total_break_time = parseTotalBreakTime(obj.break_time);
						list.push({checkin_id: mobile_checkin_id, agent: name, loc: [location_lng, location_lat], marker_color: marker_color, info_questionnaire: info_questionnaire});
						if(obj.cust_company_name != '--'){
							tableData.push(obj);
						}
					}
					setLatlongList(list);
					setCheckinData(tableData);
					snack(language.checkin_loaded);
				} else {
					snack(language.no_data, "warning");
				}
			} else {
				currentPage === 0 && snack(language.no_data, 'error');
				setCheckinData([]);
			}
			showFilter(false);
			setSearching(false);
		}).catch(err => {
			setSearching(false);
		});
	}
	const snack = (msg, type = 'success') => {
		enqueueSnackbar(msg, {
			variant: type,
			preventDuplicate: true,
			autoHideDuration: type === 'success' ? 2000 : 3000
		});
	}
	const clearValues = () => {
		setCsValue(csValue => (empty));
		setSpValue(spValue => (empty));
		setRegionSelected(regionSelected => (empty));
		setDocDateRange({});
		setStatus(status => (empty));
	}
	const showCheckinData = (mobile_checkin_id) => {
		var dataToShow = undefined;
		if(showPending){
			for (let i = 0; i < pendingData.length; i++) {
				const {mobile_checkin_id: toFind} = pendingData[i];
				if (mobile_checkin_id == toFind) {
					dataToShow = pendingData[i];
					break;
				}
			}
		}else{
			for (let i = 0; i < checkinData.length; i++) {
				const {mobile_checkin_id: toFind} = checkinData[i];
				if (mobile_checkin_id == toFind) {
					dataToShow = checkinData[i];
					break;
				}
			}
		}
		setCheckinDataToView(dataToShow);
		return dataToShow;
	}
	const columnChecking = (columnIndex) => {
		const isEnd = (tableHead[columnIndex].name == 'action') ? true : false;
		const isCheckin = (tableHead[columnIndex].name == 'checkin_location_map') ? true : false;
		const isCheckout = (tableHead[columnIndex].name == 'checkout_location_map') ? true : false;
		if(!isEnd && !isCheckin && !isCheckout){
			setShowDetails(true);
		}
	}
	const loadBranchPerCustomer = (axiosGetConfig) => {
		API_Service.get(req_branch_per_cust, axiosGetConfig).then(({data}) => {
			const {result, extraData} = data;
			const rawData = rawCustomers || [];
			if (result == 1) {
				setBranchPerCustomer(extraData);
				for (const cust_code in extraData) {
					if (Object.hasOwnProperty.call(extraData, cust_code)) {
						const branch_arr = extraData[cust_code];
						for (let ii = 0; ii < branch_arr.length; ii++) {
							const branch_obj = branch_arr[ii];
							const branchname = makebranchname(branch_obj.branch_name) || '-';
							const rawObj = {
								key: rawData.length,
								value: branchname,
								code: cust_code,
								branch_code: branch_obj.branch_code,
								branch_name: branchname,
								description: ''
							};
							for (const column_name in branch_obj) {
								if (Object.hasOwnProperty.call(branch_obj, column_name)) {
									const column_value = branch_obj[column_name];
									if (
										JString(column_name).searchTokens(['bill', 'shipp', 'name'], true) &&
										JString(column_value).isValid()
									) {
										rawObj.description += column_value;
									}
								}
							}
							rawData.push(rawObj);
						}
					}
				}
			}
			setRawCustomers(rawCustomers => (rawData));
		});
	}
	const loadRegion = (axiosRequestConfig) => {
		API_Service.get(`${req_region}`, axiosRequestConfig).then(({data}) => {
			const {result, extraData} = data;
			if (parseInt(result) === 1) {
				var _data = [{name: '-', value: '0'}];
				for (let idx = 1; idx < extraData.length; idx++) {
					_data.push({name: extraData[idx]['name'], value: idx.toString()});
				}
				_data.push({name: language.region, value: reset});
				setRegionList(regionList => (_data));
			}
		});
	}

	const regionClick = () => {
		setRegionView(true);
	};

	const regionViewClose = (newValue) => {
		setRegionView(false);
		if (newValue) {
			setRegionSelected(newValue);
		}
	};

	const getRegion = props => {
		for (let i = 0; i < regionList.length; i++) {
			const {name, value} = regionList[i];
			if (value == props) {
				return name;
			}
		}
		return empty;
	}

	const loadCustomerList = (axiosRequestConfig, salesman = 0) => {
		var parameters = '';
		if (gState.company) {
			const param = axiosURIencode({
				company: gState.company,
			});
			parameters = `?${param}`;
		}
		var req = salesman ? `${req_custby_salesman}${salesman}` : `${req_cust}${parameters}`;
		API_Service.get(req, axiosRequestConfig).then(({data}) => {
			const rawData = rawCustomers || [];
			if (data) {
				var {result, extraData: apiCust} = data;
				var {customer} = apiCust;
				var __data = apiCust;
				if (customer) {
					__data = customer;
				}
				result = JString(result).toNumber();
				if (result === 1) {
					var _data = [];
					var _outstanding = {};
					for (let idx = 0; idx < __data.length; idx++) {
						const obj = __data[idx];
						const {cust_company_name, cust_code} = obj;
						_data.push({name: cust_company_name, value: cust_code, address: makeaddress(obj), status: 1});
						const rawObj = {
							key: rawData.length,
							value: cust_company_name,
							code: cust_code,
							branch_code: '',
							branch_name: '',
							description: ''
						};
						_outstanding[cust_code] = obj.current_balance;
						for (const column_name in obj) {
							if (Object.hasOwnProperty.call(obj, column_name)) {
								const column_value = obj[column_name];
								if (
									JString(column_name).searchTokens(['bill', 'shipp', 'name'], true) &&
									JString(column_value).isValid()
								) {
									rawObj.description += column_value;
								}
							}
						}
						rawData.push(rawObj);
					}
					// _data.push({name: language.customer, value: reset});
					setCsList(csList => (_data));
					setCsOutstanding(_outstanding);
				}
			}
			setRawCustomers(rawCustomers => (rawData));
		});
	}

	const loadSalesmanList = (axiosRequestConfig, salesman = 0) => {
		var parameters = '';
		if (gState.company) {
			const param = axiosURIencode({
				company: gState.company,
			});
			parameters = `?${param}`;
		}
		API_Service.get(`${req_salesman}${parameters}`, axiosRequestConfig).then(({data}) => {
			if (data) {
				var {result, extraData: api_Sp} = data;
				result = JString(result).toNumber();
				if (result === 1) {
					var _data = [];
					var _tchList = [];
					for (let idx = 0; idx < api_Sp.length; idx++) {
						const {login, login_id, name} = api_Sp[idx];
						_data.push({name: "("+login+") "+name, value: login_id});
						_tchList.push({key: login_id, value: name});
					}
					_data.push({name: language.salesman, value: reset});
					setSpList(spList => (_data));
					setTchList(tchList => (_tchList));
				}
			}
		});
	}

	const loadMerchandiserList = (axiosRequestConfig) => {
		API_Service.get(`${req_merchandiser}`, axiosRequestConfig).then(({data}) => {
			if (data) {
				var {result, extraData: api_Sp} = data;
				result = JString(result).toNumber();
				if (result === 1) {
					var _data = [];
					for (let idx = 0; idx < api_Sp.length; idx++) {
						const {login_id, staff_code} = api_Sp[idx];
						_data.push({key: login_id, value: staff_code});
					}
					setMchList(spList => (_data));
				}
			}
		});
	}

	const spViewClick = () => {
		setSpView(true);
	};

	const spViewClose = (newValue) => {
		setSpView(false);
		if (newValue) {
			setSpValue(newValue);
			var axiosGetConfig = axiosDefaultConfig(gState.client);
			loadCustomerList(axiosGetConfig, newValue == reset ? 0 : newValue);
		}
	};

	const statusViewClick = () => {
		setStatusView(true);
	}

	const onStatusViewClose = (newValue) => {
		setStatusView(false);
		if (newValue) {
			setStatus(newValue);
		}
	}

	const getStatus = props => {
		for (let i = 0; i < statusList.length; i++) {
			const {name, value} = statusList[i];
			if (value == props) {
				return name;
			}
		}
		return empty;
	}

	const getSpName = props => {
		for (let i = 0; i < spList.length; i++) {
			const {name, value} = spList[i];
			if (value == props) {
				return name;
			}
		}
		return empty;
	}

	const onCustomerViewClose = (newValue) => {
		showCustomerView(false);
		if (typeof newValue === 'object') {
			setCsValue(newValue);
		} else {
			setCsValue(empty);
		}
	}

	const onChangedTechAssigned = (obj) => {
		const config = axiosPutConfig(gState.client);
		const params = axiosURIencode(obj);
		API_Service.put(req_checkin_sched_amend, params, config).then(({data}) => {
		});
	}

	const datefromto = (range) => {
		const {startDate, endDate} = range;
		return moment(startDate).format('DD MMMM YY') + ' / ' + moment(endDate).format('DD MMMM YY');
	}

	const onSearchClick = () => {
		[0].includes(currentPage) && loadCheckinData();
		[1].includes(currentPage) && decideAndLoad();
		[2, 3].includes(currentPage) && loadSummaryData();
	}

	const getAppointmentData = () => {
		if (_.isEmpty(selectedMch)) {
			for (let i = 0; i < mchList.length; i++) {
				const {value} = mchList[i];
				if (appointmentData && appointmentData[value]) {
					setSelectedMch(value);
					return appointmentData[value];
				}
			}
		}
		return appointmentData[selectedMch];
	}

	const onSelectMch = (value) => {
		setSelectedMch(value);
	}

	const openPrintSelectView = () => {
		setPrintView(true);
	}

	const printViewClose = (type) => {
		generateCheckinReport(type);
	}

	const approve = (doc_id) => {
		const list = [];
		const data = showCheckinData(doc_id);

		let custCategory = null;

		let outletCity = null;
		let outletState = null;
		let outletZipcode = null;
		let outletCountry = null;
		let outletLatitude = null;
		let outletLongitude = null;

		if (data.customer_not_in_list_info) {
			const json = JSON.parse(data.customer_not_in_list_info);
			if (json) {
				for (let i = 0; i < json.length; i++) {
					const {outlet_category, outlet_city, outlet_state, outlet_zipcode, outlet_country, outlet_latitude, outlet_longitude} = json[i];
					if (outlet_category) {
						custCategory = outlet_category;
					}
					if (outlet_city) {
						outletCity = outlet_city;
					}
					if (outlet_state) {
						outletState = outlet_state;
					}
					if (outlet_zipcode) {
						outletZipcode = outlet_zipcode;
					}
					if (outlet_country) {
						outletCountry = outlet_country;
					}
					if (outlet_latitude) {
						outletLatitude = outlet_latitude;
					}
					if (outlet_longitude) {
						outletLongitude = outlet_longitude;
					}
				}	
			}
		}

		if (!data.pending_customer || data.pending_customer.length === 0) {
			snack('Not Outlet Found', 'error');
			return;
		}
		
		const searchTerms = data.pending_customer[0].outlet_name.split(/[\s-]+/).map(term => term.replace(/[^a-zA-Z0-9\u00C0-\u00FF']/g, ""));
		
		const scoredList = csList.map(row => {
			let score = 0;
			searchTerms.forEach((term, index) => {

				if (!term) return;

				// Priority: Name > Address
				if (row.name && JString(row.name).searchDeep(term)) {
					score += 100;
					// Give highest priority if the first search term matches the name
					if (index === 0) score += 10000;
				}

				if (row.address && JString(row.address).searchDeep(term)) score += 10;
			});
			return { row, score };
		});

		// Sort by score descending
		scoredList.sort((a, b) => b.score - a.score);
		
		// Extract rows
		for (let i = 0; i < scoredList.length; i++) {
			list.push(scoredList[i].row);
		}
		setShowApprovementDialog(true);
		setShowApprovementList(list);
		setApproveData({
			mobile_checkin_id: data.mobile_checkin_id,
			outlet_name: data.pending_customer[0].outlet_name,
			outlet_address: data.pending_customer[0].outlet_address,
			salespersonID: data.salesperson_id,
			salespersonCode: data.staff_code,
			salespersonName: data.name,
			salespersonBranch: data.salesperson_branch,
			customerCategory: custCategory,
			outletCity: outletCity,
			outletState: outletState,
			outletZipcode: outletZipcode,
			outletCountry: outletCountry,
			outletLatitude: outletLatitude,
			outletLongitude: outletLongitude,
			checkinLatitude: data.location_lat,
			checkinLongitude: data.location_lng,
		});
	}

	const decline = (doc_id) => {
		const data = showCheckinData(doc_id);
		var params = axiosURIencode({
			mobile_checkin_id: data.mobile_checkin_id,
		});
		const isConfirmed = window.confirm("Are you sure you want to delete?");
		if (isConfirmed) {
			API_Service.put(req_checkin_delete, params, axiosApiConfig).then(({data}) => {
				const {result, message} = data;
				if (parseInt(result) == 1) {
					loadCheckinData();
					loadCustNotInListCheckinData2();
					loadTotalRecord();
					// setShowPending(false);
					// setShowPending(true);
					snack(message);
				} else {
					snack(message, 'error');
				}
			});
		}
	}

	const confirmApprove = (newValue) => {
		setShowApprovementDialog(false);
		if (newValue.value != 'RESET') {
			setIsLoading(true);
			let formData = new FormData();
			formData.append('checkin_id', approveData.mobile_checkin_id);
			formData.append('salesperson_id', approveData.salespersonID);
			formData.append('cust_code', newValue.value);
			
			const executeApprove = (value) => {
				var params = {
					checkin_id: approveData.mobile_checkin_id,
					salesperson_id: approveData.salespersonID,
					cust_code: newValue.value,
					approve: value,
				};
				params = axiosURIencode(params);
				API_Service.put(req_cust_approve, params, axiosApiConfig).then(({data}) => {
					setIsLoading(false);
					const {result, message} = data;
					if (result == 1) {
						loadCheckinData();
						loadCustNotInListCheckinData2();
						loadTotalRecord();
						// setShowPending(false);
						// setShowPending(true);
						snack(language.update_success);
					} else {
						snack(message, 'warning');
					}
				}).catch(e => {
					setIsLoading(false);
					snack(language.fail || 'Error', 'error');
				});
			};

			API_Service.post(req_sp_cust_relationship, formData, axiosApiConfig).then(({data}) => {
				const {result, extraData} = data;
				if (result == 0) {
					setIsLoading(false);
					setConfirmDialog({
						open: true,
						message: `Agent (${extraData.salesperson_name}) is not assigned to this outlet. \nDo you want to asign them to this outlet?`,
						onConfirm: () => {
							setIsLoading(true);
							executeApprove('YES');
						},
						onCancel: () => {
							setIsLoading(true);
							executeApprove('NO');
						}
					});
				} else {
					executeApprove('YES');
				}
			}).catch(e => {
				setIsLoading(false);
				snack(language.fail || 'Error', 'error');
			});
		}
	}

	// if (csList.length == 0) {
	// 	return (
	// 		<div style={{
	// 			display: "flex",
	// 			justifyContent: "center",
	// 			alignItems: "center",
	// 			height: "100vh",
	// 			width: "100%",
	// 			fontSize: "18px",
	// 			fontWeight: "bold"
	// 		}}>
	// 			Loading ...
	// 		</div>
	// 	);
	// }

	return (
		<div style={{paddingBottom: 50}}>
			<Backdrop className={classes.backdrop} open={isLoading}>
				<CircularProgress color="inherit" />
			</Backdrop>
			{
				currentPage == 0 && (
					<>
						{
							(configLoading || isSearching) ? (
								<div style={{
									display: "flex",
									justifyContent: "center",
									alignItems: "center",
									minHeight: "80vh",
									width: "100%",
									flexDirection: "column",
									gap: "16px"
								}}>
									<CircularProgress />
									<Typography>Loading</Typography>
								</div>
							) : (checkinData?.length > 0 || pendingData?.length > 0) && (
								<CheckinTable
									tableHead={tableHead}
									language={language}
									checkinData={checkinData}
									pendingsData={pendingData}
									onRowClick={(props) => {
										showCheckinData(props)
									}}
									onCellClick={(props) => {
										columnChecking(props)
									}}
									setPrintView={() => {
										openPrintSelectView()
									}}
									docTableColumnsChanged={onColumnViewChanged}
									showPending={showPending}
									onShowPending={(e) => {
										setShowPending(e);
									}}
									pendingCount={pendingCustomerCount}
									onFilterChange={(changedColumn, filterList, filterType) => {
										// 按列名快照当前筛选条件，columns重建时回填，避免筛选被清空
										const snapshot = {};
										tableHead.forEach((col, index) => {
											snapshot[col.name] = filterList[index] || [];
										});
										filterListRef.current = snapshot;
										// 只有Agent列需要持久化到localStorage，reset时changedColumn为null
										if (changedColumn !== 'name' && changedColumn !== null) {
											return;
										}
										const agentColumnIndex = tableHead.findIndex(col => col.name === 'name');
										if (agentColumnIndex === -1) {
											return;
										}
										saveFilterConditions(filterList[agentColumnIndex]);
									}}
								/>
							)
						}
					</>
				)
			}
			{
				currentPage == 1 && (
					<>
						{
							checkinData?.length == 0 && (
								<RenderMap
									lightTheme={lightTheme}
									latlongList={latlongList}
									height={'100%'}
									width={'100%'}
									mapHeight={'80vh'}
									pointerEvents={"none"}
									showCheckinData={(checkin_id) => showCheckinData(checkin_id)}
								/>
							)
						}
						{checkinData?.length > 0 && (<div style={{height: 20}}/>)}
						{
							checkinData?.length > 0 && (
								<RenderMap
									lightTheme={lightTheme}
									latlongList={latlongList}
									height={'100%'}
									width={'100%'}
									mapHeight={'40vh'}
									showCheckinData={(checkin_id) => showCheckinData(checkin_id)}
								/>
							)
						}
						{checkinData?.length > 0 && (<div style={{height: 80}}/>)}
					</>
				)
			}
			{
				[0, 1].includes(currentPage) && (
					<Fab
						className={currentPage === 3 ? commonStyles.fab2nd : commonStyles.fab}
						onClick={() => showFilter(true)}
						variant={'round'}
						size="small"
						color="primary"
						aria-label="add">
						{
							isSearching ?
								<CircularProgress color={'inherit'}/> :
								<FilterListIcon/>
						}
					</Fab>
				)
			}
			<CheckinDetails
				checkinData={checkinDataToview}
				open={showDetails}
				setClose={() => {
					setCheckinDataToView([]);
					setShowDetails(false);
				}}
				language={language}
				axiosApiConfig={axiosApiConfig}
				current_username={current_username}
				snack={snack}
				customerList={csList}
			/>
			<VirtualList
				open={isCustomerView}
				setClose={data => onCustomerViewClose(data)}
				title={language.cust_list}
				data={csList}
				language={language}
				target={'true'}
			/>
			<ListView
				classes={{
					paper: commonStyles.listView,
				}}
				id="ringtone-menu"
				open={spView}
				onClose={() => setSpView(false)}
				onSelect={spViewClose}
				value={spValue}
				title={language.salesman || ''}
				language={language}
				options={spList}
			/>
			<ListView
				classes={{
					paper: commonStyles.listView,
				}}
				id="ringtone-menu"
				open={statusView}
				onClose={() => setStatusView(false)}
				onSelect={onStatusViewClose}
				value={status}
				title={language.status || ''}
				language={language}
				options={statusList}
			/>
			<ListView
				classes={{
					paper: commonStyles.listView,
				}}
				id="ringtone-menu"
				open={regionView}
				onClose={() => setRegionView(false)}
				onSelect={regionViewClose}
				value={regionSelected}
				title={language.region || ''}
				language={language}
				options={regionList}
			/>
			<BottomNavigation
				value={currentPage}
				onChange={(event, newValue) => {
					setCurrentPage(newValue);
				}}
				showLabels
				className={commonStyles.bottomNav}>
				<BottomNavigationAction label="CheckIn List" icon={<PinDrop/>}/>
				<BottomNavigationAction label="Map" icon={<MapIcon/>}/>
				{/* <BottomNavigationAction label="Manage Schedule" icon={<AccessAlarm />} /> */}
				{
					JString(checkinConfig).isEqualDeep('merchandising') ? null :
						<BottomNavigationAction
							label="Schedule Summary"
							icon={<ViewList/>}/>
				}
				{
					JString(checkinConfig).isEqualDeep('merchandising') ? null :
						<BottomNavigationAction
							label="Presentation View"
							icon={<TvIcon/>}/>
				}
			</BottomNavigation>
			{
				openDateDoc && (
					<DateRangePickerModal
						setPositive={range => {
							setDocDateRange(range);
							setOpenDateDoc(false)
						}}
						setNegative={() => {
							setOpenDateDoc(false)
						}}
						setClose={() => {
							setOpenDateDoc(false)
						}}
						open={openDateDoc}
						message={language.date_range}
						positive={language.ok}
						negative={language.cancel}
					/>
				)
			}
			{
				editSched.open && (
					<AddVisitSched
						projectData={projectData}
						isEditing={editSched.open}
						editData={editSched.editData}
						requestReload={() => loadSchedData()}
						outstandingBalance={csOutstanding}
						customModules={customModule}
						addVisitSchedRules={addVisitSchedRules}
						onSnack={snack}
						axiosGet={axiosApiConfig}
						customerList={csList}
						open={editSched.open}
						branchList={branchPercustomer}
						onDismiss={() => setEditSched({open: false, editData: {}})}
						language={language}
						technicianList={tchList}/>
				)
			}
			{
				JString(checkinConfig).isEqualDeep('merchandising') ?
					<AddAppointmentMerchandiser
						onSnack={snack}
						axiosGet={axiosApiConfig}
						customerList={csList}
						open={addnewSched}
						onDismiss={() => showNewSched(false)}
						language={language}
						branchList={branchPercustomer}
						merchandiserList={mchList}
						requestReload={() => decideAndLoad()}/>
					:
					addnewSched && (
						<AddVisitSched
							projectData={projectData}
							requestReload={() => loadSchedData()}
							outstandingBalance={csOutstanding}
							customModules={customModule}
							addVisitSchedRules={addVisitSchedRules}
							onSnack={snack}
							axiosGet={axiosApiConfig}
							customerList={csList}
							open={addnewSched}
							branchList={branchPercustomer}
							onDismiss={(data) => {
								showNewSched(false);
								setSchedCode(data);
								data ? setSMSView(true) : setSMSView(false)
							}}
							language={language}
							technicianList={tchList}/>
					)
			}
			<GenerateView
				classes={{
					paper: commonStyles.listView,
				}}
				id="ringtone-menu"
				keepMounted
				open={printView}
				onClose={() => setPrintView(false)}
				onSelect={printViewClose}
				value={'simply'}
				title={language.generate_type || ''}
				language={language}
				options={typeOptions}
			/>
			<AnyDialog maxWidth={'lg'} keepMounted open={filterOpen} onDismiss={() => showFilter(false)}>
				<div className={paperStyle.viewInRowDialog} style={{width: 1000}}>
					<Button
						className={commonStyles.dialogFilterBtnBig}
						color="inherit"
						onClick={() => setOpenDateDoc(true)}
						size="small"
						endIcon={<KeyboardArrowRightRounded/>}
						startIcon={<EventNoteIcon/>}>
						<Typography style={{flex: 1, textAlign: 'left'}} component="p"
									className={commonStyles.searchBtnFont}>
							{!_.isEmpty(docDateRange) ? datefromto(docDateRange) : dateMenuOptions?.name}
						</Typography>
					</Button>
					<div style={{width: 20}}/>
					<Button
						disabled={csList.length === 0}
						className={commonStyles.dialogFilterBtn}
						color="inherit"
						onClick={() => showCustomerView(true)}
						size="small"
						endIcon={csList.length === 0 ? <CircularProgress size={20}/> : <KeyboardArrowDownRoundedIcon/>}
						startIcon={<BusinessIcon/>}>
						<Typography component="p" className={commonStyles.searchBtnFont}>
							{csValue?.name ? _.truncate(csValue?.name, {length: 15}) : language.customer}
						</Typography>
					</Button>
					<div style={{width: 20}}/>
					<Button
						className={commonStyles.dialogFilterBtn}
						color="inherit"
						onClick={() => spViewClick()}
						size="small"
						endIcon={<KeyboardArrowDownRoundedIcon/>}
						startIcon={<PersonIcon/>}>
						<Typography component="p" className={commonStyles.searchBtnFont}>
							{getSpName(spValue) || language.salesman}
						</Typography>
					</Button>
					<div style={{width: 20}}/>
					{
						currentPage !== 0 && (
							<Button
								className={commonStyles.dialogFilterBtn}
								color="inherit"
								onClick={() => regionClick()}
								size="small"
								endIcon={<KeyboardArrowDownRoundedIcon/>}
								startIcon={<MapIcon/>}>
								<Typography component="p" className={commonStyles.searchBtnFont}>
									{regionSelected !== empty ? getRegion(regionSelected) : language.region}
								</Typography>
							</Button>
						)
					}
					<div style={{width: 20}}/>
					{
						currentPage != 0 && (
							<Button
								className={commonStyles.dialogFilterBtn}
								color="inherit"
								onClick={() => statusViewClick()}
								size="small"
								endIcon={<KeyboardArrowDownRoundedIcon/>}
								startIcon={<WorkOutlineIcon/>}>
								<Typography component="p" className={commonStyles.searchBtnFont}>
									{getStatus(status) || language.status}
								</Typography>
							</Button>
						)
					}

				</div>
				<Divider variant={'middle'}/>
				<div className={paperStyle.viewInRowDialogEnd}>
					<ClearButton
						color="inherit"
						onClick={() => clearValues()}
						size="small"
						startIcon={<ClearAll style={{color: red[400]}}/>}>
						<Typography component="p" className={commonStyles.searchBtnFont} style={{color: red[400]}}>
							{language.clear}
						</Typography>
					</ClearButton>

					<div style={{width: 10}}/>

					<Button
						disabled={isSearching}
						color="inherit"
						onClick={() => {
							onSearchClick()
						}}
						size="small"
						startIcon={isSearching ? <CircularProgress size={20}/> : <FindInPage/>}>
						<Typography component="p" className={commonStyles.searchBtnFont}>
							{language.search_cap}
						</Typography>
					</Button>
				</div>
			</AnyDialog>
			<SendSMS
				open={smsView}
				setClose={() => {
					setSMSView(false);
					setSchedCode([]);
				}}
				language={language}
				data={schedCode}
			/>
			<VirtualListMB
				open={showApprovementDialog}
				onConfirm={data=>confirmApprove(data)}
				onCreate={()=>{setShowApprovementDialog(false);setShowCreateCustomerDialog(true);}}
				onCancel={()=>setShowApprovementDialog(false)}
				title={'Approval'}
				description={approveData?.outlet_name}
				second_description={approveData?.outlet_address}
				data={showApprovementList}
				language={language}
			/>

			<AddCustomer
				open={showCreateCustomerDialog}
				onClose={(data) => {
					setShowCreateCustomerDialog(false);
					loadCheckinData();
					loadCustNotInListCheckinData2();
					loadTotalRecord();
					// setShowPending(false);
					// setShowPending(true);
				}}
				onCancel={()=>setShowCreateCustomerDialog(false)}
				language={language}
				currentInput={approveData}
				custCategoryList={activeCustCategoryList}
				custChainList={activeCustChainList}
				branchesList={branchesList}
				custAreaList={activeCustAreaList}
				custTypeList={activeCustTypeList}
				stockTemplateList={stockTemplateList}
			/>
			<AnyDialog
				open={confirmDialog.open}
				title={language.confirmation || "Confirmation"}
				onDismiss={() => setConfirmDialog({...confirmDialog, open: false})}
				footer={() => (
					<>
						<Button onClick={() => {
							if (confirmDialog.onCancel) {
								confirmDialog.onCancel();
							}
							setConfirmDialog({...confirmDialog, open: false})
						}} color="primary">
							{language.no || 'No'}
						</Button>
						<Button onClick={() => {
							confirmDialog.onConfirm();
							setConfirmDialog({...confirmDialog, open: false});
						}} color="primary" autoFocus>
							{language.yes || 'Yes'}
						</Button>
					</>
				)}
			>
				<DialogContent>
					<DialogContentText id="alert-dialog-description">
						<Typography style={{whiteSpace: 'pre-line'}}>
							{confirmDialog.message}
						</Typography>
					</DialogContentText>
				</DialogContent>
			</AnyDialog>
		</div>
	)
}

function CheckinTableReportButton({onGenerateReport}) {
	return (
		<React.Fragment>
			<Tooltip title={'Generate Report'}>
				<IconButton
					edge={'end'}
					color={'primary'}
					onClick={() => onGenerateReport()} aria-label="addnew">
					<AssessmentIcon/>
				</IconButton>
			</Tooltip>
		</React.Fragment>
	)
}

function CheckinTable ({
													 tableHead,
													 language,
													 checkinData,
													 pendingsData,
													 onRowClick,
													 onCellClick,
													 setPrintView,
													 docTableColumnsChanged,
													 showPending,
													 onShowPending,
													 pendingCount,
													 onFilterChange
												 }) {
	const theme = useTheme();
	const filterTheme = useMemo(() => createDataTableFilterTheme(theme), [theme]);
	if (checkinData.length === 0 && pendingsData.length === 0) {
		return null;
	}
	return (
		<MuiThemeProvider theme={filterTheme}>
		<MUIDataTable
			title={language.checkin}
			data={showPending ? pendingsData : checkinData}
			columns={tableHead}
			options={{
				print: false,
				filter: true,
				textLabels: {
					filter: {
						title: language.filter_table,
						reset: language.reset,
						all: language.all
					},
					toolbar: {
						filterTable: language.filter_table
					}
				},
				download: true,
				selectableRows: 'none',
				rowsPerPage: 25,
				rowsPerPageOptions: [25, 40, 65, 100],
				responsive: 'simple',
				onRowClick: (rowData) => {
					onRowClick(rowData[0])
				},
				onCellClick: (cellData, cellMeta) => {
					onCellClick(cellMeta.colIndex)
				},
				setTableProps: () => ({size: 'small'}),
				// customToolbar:()=>
				//     <>
				//         <CheckinTableReportButton onGenerateReport={setPrintView}/>
				//     </>,
				onColumnViewChange: (changedColumns, action) => {
					docTableColumnsChanged(changedColumns, action);
				},
				onFilterChange: (changedColumn, filterList, type) => {
					if (onFilterChange) {
						onFilterChange(changedColumn, filterList, type);
					}
				},
				downloadOptions: {
					filterOptions: {
						useDisplayedColumnsOnly: false,
						useDisplayedRowsOnly: true
					}
				},
				onDownload: (buildHead, buildBody, columns, data) => {
					const processedData = data.map(row => {
						const processedRow = [...row.data];
						// 处理schedule列 (假设它是第16列，根据实际情况调整)
						const scheduleIndex = columns.findIndex(col => col.name === 'schedule');
						if (scheduleIndex !== -1 && processedRow[scheduleIndex]) {
							const scheduleValue = processedRow[scheduleIndex];
							if (typeof scheduleValue === 'object' && scheduleValue !== null) {
								if (Object.keys(scheduleValue).length > 0 && scheduleValue.appmnt_date) {
									processedRow[scheduleIndex] = moment(scheduleValue.appmnt_date).format('DD/MM/YYYY');
								} else {
									processedRow[scheduleIndex] = '-';
								}
							}
						}
						return {
							...row,
							data: processedRow
						};
					});
					return buildHead(columns) + buildBody(processedData);
				},
				customToolbar: () => {
					return (
						<>
						{
							showPending ? (
								<Tooltip title={'Show Active'}>
									<IconButton
										onClick={() => {
											onShowPending(false);
										}}>
										<NewReleasesIcon/>
									</IconButton>
								</Tooltip>
							) : (
								<Tooltip title={'Show Pending Only'}>
									<IconButton
										onClick={() => {
											onShowPending(true);
										}}>
										{
											pendingCount > 0 ? <NewReleasesIcon color={'primary'}/> : <NewReleasesIcon color={'secondary'}/>
										}
									</IconButton>
								</Tooltip>
							)
						}
						<span>Pending: {pendingCount}</span>
						</>
					);
				}
			}}
		/>
		</MuiThemeProvider>
	)
}

const AppointmentTable = React.memo(({language, appointmentData, onRowClick}) => {
	if (appointmentData.length == 0) {
		return null;
	}
	return (
		<MUIDataTable
			title={language.schedules}
			data={appointmentData}
			columns={appointmentHeadCell}
			options={{
				print: false,
				filter: true,
				selectableRows: 'none',
				rowsPerPage: 125,
				rowsPerPageOptions: [125, 140, 165, 200],
				responsive: 'simple',
				onRowClick: (rowData, {dataIndex}) => {
					onRowClick(dataIndex);
				},
				rowsSelected: [],
				setTableProps: () => ({size: 'small'})
			}}
		/>
	)
}, (prevProps, nextProps) => prevProps.appointmentData.length === nextProps.appointmentData.length);

const ScheduleTable = React.memo(({language, scheduleData, onRowClick}) => {
	if (scheduleData.length === 0) {
		return null;
	}
	const onClick = (dataIndex) => {
		onRowClick && onRowClick({
			open: true,
			editData: scheduleData[dataIndex]
		})
	}

	return (
		<MUIDataTable
			title={language.schedules}
			data={scheduleData}
			columns={schedHeadCell}
			options={{
				print: false,
				filter: true,
				selectableRows: 'none',
				rowsPerPage: 125,
				rowsPerPageOptions: [125, 140, 165, 200],
				responsive: 'simple',
				onRowClick: (rowData, {dataIndex}) => {
					onClick(dataIndex);
				},
				rowsSelected: [],
				setTableProps: () => ({size: 'small'})
			}}
		/>
	)
}, areEqualSched);

function areEqualSched(prevProps, nextProps) {
	return prevProps.scheduleData.length === nextProps.scheduleData.length;
}

function areEqual(prevProps, nextProps) {
	return prevProps.checkinData.length === nextProps.checkinData.length;
}

const RenderMap = pure(({
							lightTheme,
							latlongList,
							height = '100%',
							width = '20%',
							mapHeight = '50vh',
							mapWidth = '100%',
							showCheckinData,
							...others
						}) => {
	const Map = ReactMapboxGl({accessToken: mapbox_key});
	const [currentLocation, setCurrentLocation] = useState([101.621420, 3.142540]);

	const clickmark = (item) => {
		showCheckinData(item.checkin_id);
	}

	useEffect(() => {
		position();
	}, [latlongList]);

	const position = () => {
		navigator.geolocation.getCurrentPosition(
			position => setCurrentLocation([position.coords.longitude, position.coords.latitude]),
			err => de(err)
		);
	}

	return (
		<div style={{height: height, width: width, ...others}}>
			<Map
				center={currentLocation}
				style={lightTheme ? "mapbox://styles/mapbox/light-v10" : "mapbox://styles/mapbox/dark-v10"}
				containerStyle={{
					height: mapHeight,
					width: mapWidth
				}}>
				<RenderMarkerPopup
					latlongList={latlongList}
					onClick={(item) => clickmark(item)}
				/>
			</Map>
		</div>
	)
});
const RenderMarkerPopup = pure(({latlongList, onClick}) => {
	const [popupData, setPopupData] = useState({show: false, loc: [], text: '', id: ''});
	return (
		<div>
			{
				latlongList && latlongList.map((item, index) =>
					<Marker
						onMouseEnter={() => setPopupData({
							show: true,
							loc: item.loc,
							text: item.agent,
							id: item.checkin_id
						})}
						onMouseLeave={() => setPopupData({show: false, loc: [], text: ''})}
						key={String(index)}
						coordinates={item.loc}
						anchor="bottom">
						<RoomIcon color={'primary'} onClick={() => onClick(item)} style={{ color: item.marker_color }}/>
					</Marker>
				)
			}
			{
				popupData.show && (
					<Popup
						coordinates={popupData.loc}
						anchor={'top'}>
						<Typography color={"error"} style={{alignItems: 'center', display: 'flex', whiteSpace: 'pre-line'}}>
							{popupData.text}
						</Typography>
					</Popup>
				)
			}
		</div>
	)
});
